'use client';

import { createOpenAPIPage } from 'fumadocs-openapi/ui';

export const OpenAPIPageClient = createOpenAPIPage();
